
// Converts string to title case e.g. sHopgrok -> Shopgrok
export const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, (word) =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
};

export const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const dayMap = {
  Mon: "Monday",
  Tue: "Tuesday",
  Wed: "Wednesday",
  Thu: "Thursday",
  Fri: "Friday",
  Sat: "Saturday",
  Sun: "Sunday"
};

export const hasDuplicateKeys = (arr) => {
        const keys = arr.map(arg => arg.key.trim()).filter(Boolean); // ignore empty keys
        const uniqueKeys = new Set(keys);
    return uniqueKeys.size < keys.length;
};

export const safeParse = (str) => {
  try {
    return JSON.parse(str);
  } catch {
    return {}; // Return empty object so chaining doesn't break
  }
};